module.exports = __webpack_public_path__ + "static/media/Sonic.ec8d9eb9.jpg";